export default __webpack_public_path__ + "static/media/Shampoo_SPLING_LIFT_250_N.a8839462.png";